<template>
    <div class="load_pdf">
        <div class="load_pdf_wrapper">
            <div class="item_header">
                <div class="progress_wrapper" v-if="showProgress">
                    <md-progress-spinner :md-diameter="60" class="md-accent" id="progressbar"
                                         md-mode="indeterminate"></md-progress-spinner>
                </div>
                <div :style="getIconStyle()" class="icon" v-if="icon"/>
            </div>
            <div class="desc">
                {{this.desc}}
            </div>
            <div class="help" v-if="showHelp">
                {{translate('signIn_contact')}} <span><a class="help-link" href="mailto:team@air-vote.com">team@air-vote.com</a></span>
            </div>
        </div>
    </div>


</template>

<script>

    import mapMixin from '@/mixins/mapMixin';
    import errorMixin from '@/mixins/errorMixin';
    import questionMixin from '@/mixins/questionMixin';
    import customModalDialog from '@/components/widgets/customModalDialog';
    import config from '@/api/config';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

    export default {
        name: 'mainLayout',

        mixins: [mapMixin, errorMixin, questionMixin],

        components: {
            customModalDialog,
        },

        data() {
            return {
                pdfUid: null,
                icon: null,
                showProgress: true,
                showHelp: false,
                desc: this.translate('loadPdfProgress'),
            }
        },

        computed: {
            ...mapGetters({
            }),
            ...mapState({
                accessToken: state => state.auth.accessToken,
                userInfo: state => state.auth.userInfo
            }),
        },

        watch: {},

        methods: {
            ...mapActions({
                chekPdfStatus: 'pdf/chekPdfStatus',
            }),

            ...mapMutations({
                setLanguage: 'setLanguage',
                removeKeys: 'auth/removeKeys',
            }),

            getIconStyle() {
                if (this.icon) {
                    return {
                        backgroundImage: 'url(' + require(`@/assets/icons/${this.icon}`) + ')'
                    }
                } else {
                    return null
                }
            },

            async checkPdf() {
                this.pdfUid = this.$route.params.pdfUid
                this.intervalId = setInterval(() => {
                    this.chekPdfStatus(this.pdfUid).then((response) => {
                        this.pdfStatus = response
                        if (response.status === 'done') {
                            clearInterval(this.intervalId);
                            this.showProgress = false
                            this.icon = 'ic_allow.svg'
                            this.showPdf()
                        }
                        if (response.status === 'error') {
                            this.showError(response.error)
                        }
                    }).catch((e) => {
                        this.showError(e.data.error.message)
                    });
                }, 500)
            },

            showError(msg) {
                clearInterval(this.intervalId);
                this.showProgress = false
                this.icon = 'close-circle-outline.svg'
                this.showHelp = true
                this.desc = msg
            },

            async showPdf() {
                location.replace(`${config.baseUrl}/admin/pdf/${this.pdfUid}`)
            },
        },

        mounted() {
            this.checkPdf()
        },

    }
</script>

<style>

    .load_pdf .md-accent svg {
        stroke: #438348;
    }
</style>
<style scoped>
    .load_pdf {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 100px;
    }

    .item_header {
        margin-top: 40px;
    }

    .load_pdf_wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 4px;
        background-color: #FFFFFF;
        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.12);
        height: 260px;
        width: 400px;
    }

    @media screen and (max-width: 426px) {
        .load_pdf_wrapper {
            width: 300px;
        }

    }

    .load_pdf_wrapper #progressbar {
        padding: 10px;
    }

    .desc {
        text-align: center;
        font-size: 16px;
        line-height: 28px;
        margin-top: 12px;
        white-space: pre-line;
    }

    .help {
        margin-top: 8px;
        color: #3F405C;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
        padding-left: 10px;
        padding-right: 10px;
    }

    .help-link {
        color: #1976D2;
        text-decoration: none;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        white-space: nowrap;
    }

    .help-link:hover {
        text-decoration: none;
    }

    .icon {
        width: 80px;
        height: 80px;
        background-repeat: no-repeat;
        background-size: 80px;
        background-image: url("~@/assets/icons/close-circle-outline.svg");
    }

</style>

